import { render, staticRenderFns } from "./ModalMoverDocumento.vue?vue&type=template&id=24bc1366&scoped=true"
import script from "./ModalMoverDocumento.vue?vue&type=script&lang=js"
export * from "./ModalMoverDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc1366",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24bc1366')) {
      api.createRecord('24bc1366', component.options)
    } else {
      api.reload('24bc1366', component.options)
    }
    module.hot.accept("./ModalMoverDocumento.vue?vue&type=template&id=24bc1366&scoped=true", function () {
      api.rerender('24bc1366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/ModalMoverDocumento.vue"
export default component.exports